@if (success) {
  <h1>{{ 'CALLS.HANG_UP.REQUEST_RECEIVED' | translate }}</h1>
}
